import { latestContent } from "@/mocks/siteData";
import VideoCard from "@/components/base/VideoCard";

export default function LatestContent() {
  return (
    <section className="w-full bg-background-50 py-12 md:py-16">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">最新更新</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">每日更新精彩内容，不错过任何一个好作品</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {latestContent.map((video) => (
            <VideoCard key={video.id} {...video} />
          ))}
        </div>
      </div>
    </section>
  );
}